export { useDomainSelectionTable } from './use-domain-selection-table';
